import { Checkbox } from "@mui/material";

export const CheckboxRenderer = (params: any) => {
  return <Checkbox checked={params.value} disabled={true} />;
};
